module.exports = __webpack_public_path__ + "images/emoji/melon.a921ead92d3adedb74a2.png";